// eslint-disable-next-line
import { h, Component } from 'preact';
import IconError from '../../../IconError';
import HorizontalLine from '../../../HorizontalLine';
import formatPrice from '../../../../utils/formatPrice';

import styles from '../../index.scss';

class ProductListItem extends Component {
    state = {
        isOpen: false,
        showTooltip: false,
    };
    timerId = null;

    componentWillUnmount() {
        clearTimeout(this.timerId);
    }

    returnTooltip(text) {
        return (
            <div
                className={styles.tooltipContent}
                onMouseEnter={this.handleMouseEnterOnContent}
                onMouseLeave={this.handleMouseLeave}
            >
                {text}
            </div>
        );
    }

    renderPrice = (listPrice, salePrice, isAvailable) => {
        if (salePrice) {
            return (
                <div className={styles.list__itemPromo}>
                    <div className={styles.list__itemPromoPriceOld}>{listPrice}</div>
                    <div
                        className={styles.list__itemPromoPriceNew}
                        dangerouslySetInnerHTML={{
                            __html: formatPrice(salePrice, styles.list__itemPromoPriceNewFraction),
                        }}
                    />
                </div>
            );
        } else if (!isAvailable) {
            return (
                <div
                    className={`${styles.list__itemPrice} ${styles.list__itemPrice_unavailable}`}
                    dangerouslySetInnerHTML={{
                        __html: formatPrice(listPrice, styles.list__itemPriceFraction),
                    }}
                />
            );
        }

        return (
            <div
                className={styles.list__itemPrice}
                dangerouslySetInnerHTML={{
                    __html: formatPrice(listPrice, styles.list__itemPriceFraction),
                }}
            />
        );
    };

    renderExtraInfo = () => {
        const { item, unavailable_firstUppercase } = this.props;

        if (item.isAvailable && !item.partnerPriceName) return null;

        return (
            <div className={styles.list__itemExtraInfo}>
                <div>
                    {item.isAvailable ? null : (
                        <div className={styles.list__itemUnavailable}>
                            <IconError />&nbsp;
                            <span className={styles.list__itemUnavailableText}>{unavailable_firstUppercase}</span>
                        </div>
                    )}
                </div>
                <div className={styles.list__itemResellerName}>
                    {item.partnerPriceName ? item.partnerPriceName : null}
                </div>
            </div>
        );
    };

    handleMouseEnter = ev => {
        ev && ev.preventDefault && ev.preventDefault();
        clearTimeout(this.timerId);
        this.setState({ showTooltip: true });
    };

    handleMouseLeave = ev => {
        ev && ev.preventDefault && ev.preventDefault();

        clearTimeout(this.timerId);
        this.timerId = setTimeout(() => {
            this.setState({
                showTooltip: false,
            });
        }, this.props.delayTime);
    };

    handleMouseEnterOnContent = ev => {
        ev && ev.preventDefault && ev.preventDefault();
        clearTimeout(this.timerId);
    };

    render() {
        const { item, index, ecommerce_keyword_qty } = this.props;

        return (
            <li className={styles.list__item} key={index}>
                {index === 0 ? <HorizontalLine /> : null}
                <div className={styles.list__itemInner}>
                    <div className={styles.list__itemPic} style={{ backgroundImage: `url(${item.imageUrl})` }} />
                    <div className={styles.list__itemContent}>
                        <div className={styles.list__itemContentInner}>
                            <div className={styles.list__itemDescription}>
                                <div
                                    className={`${styles.list__itemTitle} ${styles.tooltipWrapper}`}
                                    onMouseEnter={this.handleMouseEnter}
                                    onMouseLeave={this.handleMouseLeave}
                                >
                                    {item.truncatedDisplayName}
                                    {this.state.showTooltip ? this.returnTooltip(item.displayName) : null}
                                </div>
                                <div className={styles.list__itemAuxInfo}>
                                    <div className={styles.list__itemSKU}>{item.partNum}</div>
                                    <div className={styles.list__itemQTY}>{`${ecommerce_keyword_qty} ${item.qty}`}</div>
                                </div>
                            </div>
                            <div className={styles.list__itemPriceBlock}>
                                {this.renderPrice(item.listPrice, item.salePrice, item.isAvailable)}
                                <div className={styles.list__itemPriceProvider}>
                                    {item.isTradeUpsItem ? (
                                        <img
                                            src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBQNDAsLDBkSEw8UHRofHh0aHBwgJC4nICIsIxwcKDcpLDAxNDQ0Hyc5PTgyPC4zNDL/2wBDAQkJCQwLDBgNDRgyIRwhMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjL/wAARCAAPAEEDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD2NPGXh2WRUTV7ZmchVAbqTW5XkmsWSQeNNd8i3jjjj09niCKAEYKuCB2PvUN9dajaaBpLPfX8j30ckpka5PyuBgKACD2B5OKAPWry9ttPtJLq7mWGCMZd26DtT4LiK5t454XDxSKGRh0IPQ14pq97qlzZW8d/dXUqz6arQqsvyswbkuM89D+lWLq71m3vNPtxfXEG+2t/sKxPx0GeNwHXOd1AHrt/qFpptqbm9uEggBALueMnpXAR6y0XxJnkl1eX+zBbCbLMNmwqCOMdOfrVvxXpniW88PagLu5sp4BtkjiiQo4w2eSeDxXFQLNq0ep6jDDtgt9NSB9zDO4BVGPrgmgD1218UaHeu62+qWzsil2G/GAOp5qGPxdoVyXFtqEc7oMmOIEsRnsO/wCFcLo3g0XHh1NZuXe5YWjpHZpti45HL9z1PNQeA3nl8T28dkGktIY2EwuUQtD14Vhz1I6Y6mgD1jzl/wBr8jRT8fX86KAP/9k="
                                            alt="TradeUps logo"
                                        />
                                    ) : null}
                                </div>
                            </div>
                        </div>

                        {this.renderExtraInfo(item)}
                    </div>
                </div>
                <HorizontalLine />
            </li>
        );
    }
}

export default ProductListItem;
